<template>
    <div class="navbarAll">
      <!-- 第二層 -->
      <el-row>
        <el-col class="el-img-logo" :span="4">
          <img src="@/assets/img/logo-4.png" alt="icon-logo">
        </el-col>
        <el-col :span="16" class="el-center">
          <div class="navbarCenter">
            <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" @select="handleSelect" active-text-color="#00a9e0">
                <el-menu-item index="1">首 頁</el-menu-item>
                <el-menu-item index="2" @click="goSport()">背 包</el-menu-item>
                <el-menu-item index="3" @click="goUniform()">書 包</el-menu-item>
                <el-menu-item index="4" @click="goOther()">手 提 包</el-menu-item>
                <el-menu-item index="5" @click="goOther()">帽 子</el-menu-item>
                <el-submenu index="6">
                    <template slot="title">其 他 產 品</template>
                    <el-menu-item index="6-1" @click="goMask()">口 罩</el-menu-item>
                    <el-menu-item index="6-1" @click="goOther()">圍 兜</el-menu-item>
                    <el-menu-item index="6-2" @click="goOther()">圍 裙</el-menu-item>
                    <el-submenu index="6-4">
                        <template slot="title">床上用品</template>
                        <el-menu-item index="6-4-1">枕頭套</el-menu-item>
                        <el-menu-item index="6-4-2">床墊套</el-menu-item>
                    </el-submenu>
                </el-submenu>
            </el-menu>
          </div>
        </el-col>
        <el-col class="el-right-input" :span="4">
          <el-input v-model="input" placeholder="請輸入商品號碼" suffix-icon="el-icon-search" size="small"></el-input>
        </el-col>
      </el-row>
      <div class="navbottom">
        <p/>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'NavBar',
    data() {
      return {
        activeIndex: '1',
        input: ''
      };
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      },
      goSport() {
        document.getElementById('sport').scrollIntoView();
        // this.$refs.sport2.scrollIntoView(true);
      },
      goUniform() {
        alert('即將上市，敬請期待！');
        // document.getElementById('uniform').scrollIntoView();
        // this.$refs.sport2.scrollIntoView(true);
      },
      goMask() {
        alert('即將上市，敬請期待！');
        // document.getElementById('MaskInfo').scrollIntoView();
        // this.$refs.sport2.scrollIntoView(true);
      },
      goBag() {
        alert('即將上市，敬請期待！');
        // document.getElementById('uniform').scrollIntoView();
        // this.$refs.sport2.scrollIntoView(true);
      },
      goHat() {
        alert('即將上市，敬請期待！');
        // document.getElementById('uniform').scrollIntoView();
        // this.$refs.sport2.scrollIntoView(true);
      },
      goOther() {
        // document.getElementById('uniform').scrollIntoView();
        alert('即將上市，敬請期待！');
      }
    }
  };

</script>
<style lang="scss" scoped>
  @import '~assets/scss/mixins';

  .navbarAll {
    background-color: $bgc-fff;
    border-top: 1px solid #d6d6d6;
    .el-row {
      @include flex-only-center();
      width: 60%;
      margin: 0 auto;
      align-items: space-between;
      line-height: 80px;

      .el-img-logo {
        img {
          width: 80px;
        }
      }
      .el-center{
        // @include flex-only-center();
        // align-items: center;
      }
      .el-menu-demo {
        @include flex-only-center();
        background-color: none;
        border: 0px;
      }
    }
    .navbottom {
      height: 40px;
      background-color: #eee;
      border-bottom: 2px solid $bgc-blue;
    }
  }
  @media screen and (min-width: 1920px){}
  @media (min-width:1366px) and (max-width:1920px){
    .navbarAll {
      .el-row {
        width: 80%;
      }
    }
  }
  @media (min-width:1024px) and (max-width:1365px){
    .navbarAll {
      .el-row {
        width: 90%;
      }
    }
  }
  @media screen and (max-width: 1023px){
    .navbarAll {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/navbar/index.vue